import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { DetailPageLayout } from '@/components/layouts';
import { OttoReportView } from '@/components/ai/otto/OttoReportView';
import { Fullbleed } from '@/contexts/fullbleed';
import { useOttoReport } from '@/lib/ai/otto';

export const Route = createFileRoute('/_dashboard/dashboard/ai/otto/$reportId')({
  component: OttoReportPage,
});

function OttoReportPage() {
  const { reportId } = Route.useParams();
  const report = useOttoReport(reportId);

  return (
    <>
      <Fullbleed />
      <DetailPageLayout
        header={
          <div className="flex min-w-0 items-center gap-2">
            <Link
              to="/dashboard/ai/otto"
              className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="size-3.5" />
              Otto
            </Link>
          </div>
        }
      >
        <div className="h-full min-h-0 p-1">
          {report.isLoading ? (
            <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
              <Loader2 className="mr-2 size-4 animate-spin" />
              Loading report…
            </div>
          ) : report.data ? (
            <OttoReportView report={report.data} />
          ) : (
            <div className="flex h-full items-center justify-center rounded-lg border border-dashed text-sm text-muted-foreground">
              Report not found.
            </div>
          )}
        </div>
      </DetailPageLayout>
    </>
  );
}
